import React from 'react';
import { Globe, Diamond, Shield } from 'lucide-react';
import BlurredPrice from './BlurredPrice';

const DomainCard = ({ domain, price, currency = 'ETH', isPremium, onRequest }) => {
  if (isPremium) {
    return (
      <div className="relative w-full bg-black rounded-lg p-8 group transition-all duration-300">
        <div className="absolute -top-2.5 left-6">
          <div className="px-3 py-1 bg-black border border-amber-500/20 rounded-full">
            <div className="text-xs font-medium text-amber-500/80 uppercase tracking-wider flex items-center gap-1">
              <Diamond size={10} />
              Premium
            </div>
          </div>
        </div>
        <div className="absolute inset-0 rounded-lg">
          <div className="absolute inset-0 rounded-lg border border-amber-500/20" />
          <div className="absolute inset-0 rounded-lg border border-amber-500/10 blur-sm" />
        </div>
        <div className="relative space-y-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Shield className="w-3.5 h-3.5 text-amber-500/70" />
              <div className="text-sm text-amber-500/70 uppercase tracking-wider">
                Premium Domain
              </div>
            </div>
            <h3 className="text-2xl font-medium text-white group-hover:text-white-100 transition-colors duration-300">
              {domain}
            </h3>
          </div>

          {/* Horizontal rule added */}
          <hr className="border-t border-amber-500/20" />

          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <div className="text-xs text-gray-500 uppercase tracking-wider">
                Current Price
              </div>
              <BlurredPrice 
                price={price} 
                currency={currency} 
                className="text-lg font-medium text-amber-500/90"
              />
            </div>
            <button 
            onClick={() => onRequest(domain)}
            className="px-5 py-2 bg-black border border-amber-500/20 rounded-lg text-amber-500/90 hover:bg-amber-500/5 transition-all duration-300">
              Request
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  // return (
  //   <div className="relative w-full bg-black border border-gray-800 rounded-lg p-8 hover:border-gray-700 transition-all duration-200">
  //     <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(at_top_right,rgba(255,255,255,0.03),transparent)] rounded-lg" />
  //     <div className="relative space-y-6">
  //       <div>
  //         <div className="flex items-center gap-2 mb-1">
  //           <Globe className="w-4 h-4 text-gray-500" />
  //           <div className="text-sm text-gray-500 uppercase tracking-wider">
  //             Domain
  //           </div>
  //         </div>
  //         <h3 className="text-2xl font-medium text-white">{domain}</h3>
  //       </div>
        
  //       {/* Horizontal rule added */}
  //       <hr className="border-t border-gray-800 my-4" />

  //       <div className="flex items-center justify-between">
  //         <div className="space-y-1">
  //           <div className="text-xs text-gray-500 uppercase tracking-wider">
  //             Price
  //           </div>
  //           <div className="text-lg text-gray-300">{price} {currency}</div>
  //         </div>
  //         <button 
  //         onClick={() => onRequest(domain)}
  //         className="px-4 py-2 text-sm text-gray-300 border border-gray-800 rounded-lg hover:bg-gray-900 transition-all duration-200">
  //           Request
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
    <div className="relative w-full bg-black rounded-lg p-8 border border-gray-800 transition-all duration-300">
      {/* Enhanced Badge in Top-Right */}
      <div className="absolute -top-3 -right-3">
        <div className="relative">
          {/* Badge Glow Effect */}
          <div className="absolute inset-0 bg-amber-500/20 blur-md rounded-full"></div>
          {/* Badge Itself */}
          <div className="relative px-3 py-1.5 bg-gradient-to-r from-amber-600 to-amber-500 rounded-full border border-amber-400/50 shadow-lg">
          <div className="text-xs font-bold text-black uppercase tracking-wider flex items-center gap-1">
            <Diamond size={10} className="text-black" />
              EXCLUSIVE
            </div>
          </div>
        </div>
      </div>
      
      {/* Subtle Corner Accents */}
      <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden">
        <div className="absolute top-0 right-0 w-12 h-12 border-t-2 border-r-2 border-amber-500/20 rounded-tr-lg"></div>
      </div>
      <div className="absolute top-0 left-0 w-16 h-16 overflow-hidden">
        <div className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-gray-700 rounded-tl-lg"></div>
      </div>
      <div className="absolute bottom-0 right-0 w-16 h-16 overflow-hidden">
        <div className="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-gray-700 rounded-br-lg"></div>
      </div>
      <div className="absolute bottom-0 left-0 w-16 h-16 overflow-hidden">
        <div className="absolute bottom-0 left-0 w-12 h-12 border-b-2 border-l-2 border-gray-700 rounded-bl-lg"></div>
      </div>
      
      <div className="relative space-y-6">
        {/* Domain Label & Name */}
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Globe className="w-4 h-4 text-gray-500" />
            <div className="text-gray-500 uppercase text-sm">
              DOMAIN
            </div>
          </div>
          <h3 className="text-2xl font-medium text-white transition-colors duration-300">
            {domain}
          </h3>
        </div>
        
        {/* Price & Request Button */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-800">
          <div>
            <div className="text-gray-500 uppercase text-xs tracking-wider">PRICE</div>
            <BlurredPrice 
              price={price} 
              currency={currency} 
              className="text-white text-xl"
            />
          </div>
          <button 
            onClick={() => onRequest(domain)}
            className="px-5 py-2 bg-black border border-amber-500/30 rounded-lg text-amber-500 hover:bg-amber-500/5 transition-all duration-300"
          >
            Request
          </button>
        </div>
      </div>
    </div>
  );  
};

export default DomainCard;